<!-- --------------------------------- --> 
<ion-content class="ion-no-padding">
  <div class="model-container">
    <ion-header class="model-header ion-no-border ion-padding-horizontal sticky-top bg-white">
      <ion-toolbar class="header-first-toolbar">
        <ion-title class="text-start ion-no-padding title-blue"><span *ngIf="!viewOnlyTemplate">Edit </span>Template</ion-title>
        <ion-buttons slot="end" class="ion-no-margin">
          <ion-button class="filled-blue-btn" (click)="setTemplateAsDefault()" *ngIf="!isTemplateDefault">
            Set As Default
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="enableEdit()" *ngIf="viewOnlyTemplate">
            Edit
          </ion-button>
          <ion-button class="filled-blue-btn" (click)="onSubmit()" *ngIf="!viewOnlyTemplate" [disabled]="!formDataModified()">
            Save
          </ion-button>
          <ion-button class="unfilled-gray-btn" (click)="closeModal()">
            <ion-icon name="close-outline"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>

      <!-- Form Start-->
      <form [formGroup]="templateDetailsForm" *ngIf="!viewOnlyTemplate">
        <div>  
          <div class="form-container ion-padding-horizontal">      
            <div class="row">
              <div class="col-2">
                <div class="input-container">
                  <label for="" class="label">Theme Color 1</label>
                  <div>
                    <input type="color" class="input" formControlName="primaryColor">
                  </div>
                </div>
              </div>
              <div class="col-2">
                <div class="input-container">
                  <label for="" class="label">Theme Color 2</label>
                  <div>
                    <input type="color" class="input" formControlName="secondaryColor">
                  </div>
                </div>
              </div>
      
              <div class="col-3">
                <div class="input-container">
                  <label for="" class="label">Enquiry Phone Number 1*</label>
                  <div [ngClass]="{ 'invalid-input': templateDetailsForm.get('enquiryNumber1')?.invalid && templateDetailsForm.get('enquiryNumber1')?.touched }">
                    <app-phone-country-input formControlName="enquiryNumber1"></app-phone-country-input>
                  </div>
                </div>  
              </div>
            
              <div class="col-3">
                <div class="input-container">
                  <label for="" class="label">Enquiry Phone Number 2*</label>
                  <div [ngClass]="{ 'invalid-input': templateDetailsForm.get('enquiryNumber2')?.invalid && templateDetailsForm.get('enquiryNumber2')?.touched }">
                    <app-phone-country-input formControlName="enquiryNumber2"></app-phone-country-input>
                  </div>
                </div>  
              </div>
              <!-- <div class="col-2">
                <div class="d-flex align-items-end h-100 pb-1">
                  <ion-button class="unfilled-blue-btn">Preview</ion-button>
                </div>
                
              </div> -->
            </div>
            
          </div>
        </div>
      </form>
      <!-- Form end -->

    </ion-header>

    <div class="model-content" >
      <div class="template-data-html d-flex justify-content-center" [innerHTML]="templateHtml"></div>
    </div>

  </div>
</ion-content>



<!-- ---------------------- -->
  
